import TableCellRenderer from "../../../../table/TableCellRenderer"

class EditableCellRenderer extends TableCellRenderer {
    init()
    {
        TableCellRenderer.apply(this, arguments)
        return this
    }

    setEditorSelected()
    {
        this.addExtraClass("editorSelected");
    }

    unsetEditorSelected()
    {
        this.removeExtraClass("editorSelected");
    }
}

export default EditableCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/EditableCellRenderer.js